var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 19.3333H2.66667C2.48986 19.3333 2.32029 19.2631 2.19526 19.1381C2.07024 19.013 2 18.8435 2 18.6667C2 18.4899 2.07024 18.3203 2.19526 18.1953C2.32029 18.0702 2.48986 18 2.66667 18H21.3333C21.5101 18 21.6797 18.0702 21.8047 18.1953C21.9298 18.3203 22 18.4899 22 18.6667C22 18.8435 21.9298 19.013 21.8047 19.1381C21.6797 19.2631 21.5101 19.3333 21.3333 19.3333Z",
    fill: "#00CCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 12.6668H2.66667C2.48986 12.6668 2.32029 12.5966 2.19526 12.4716C2.07024 12.3465 2 12.177 2 12.0002C2 11.8234 2.07024 11.6538 2.19526 11.5288C2.32029 11.4037 2.48986 11.3335 2.66667 11.3335H21.3333C21.5101 11.3335 21.6797 11.4037 21.8047 11.5288C21.9298 11.6538 22 11.8234 22 12.0002C22 12.177 21.9298 12.3465 21.8047 12.4716C21.6797 12.5966 21.5101 12.6668 21.3333 12.6668Z",
    fill: "#00CCBC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 5.99984H2.66667C2.48986 5.99984 2.32029 5.9296 2.19526 5.80458C2.07024 5.67955 2 5.50998 2 5.33317C2 5.15636 2.07024 4.98679 2.19526 4.86177C2.32029 4.73674 2.48986 4.6665 2.66667 4.6665H21.3333C21.5101 4.6665 21.6797 4.73674 21.8047 4.86177C21.9298 4.98679 22 5.15636 22 5.33317C22 5.50998 21.9298 5.67955 21.8047 5.80458C21.6797 5.9296 21.5101 5.99984 21.3333 5.99984Z",
    fill: "#00CCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMenu);
export default __webpack_public_path__ + "static/media/icon-menu.aa241bafd18894d39075bd55770be6f4.svg";
export { ForwardRef as ReactComponent };